export function getIconPath(nombreArchivo) {
    console.log('Holaaaaa '+nombreArchivo)
    let img;
    let ext = nombreArchivo.split('.').pop();
    switch (ext) {
      case 'ico':
      case 'gif':
      case 'jpg':
      case 'jpeg':
      case 'jpc':
      case 'jp2':
      case 'jpx':
      case 'xbm':
      case 'wbmp':
      case 'png':
      case 'bmp':
      case 'tif':
      case 'tiff':
      case 'webp':
      case 'avif':
      case 'svg':
        img = ['fas', 'image'];
        console.log(img);
        break;
      case 'passwd':
      case 'ftpquota':
      case 'sql':
      case 'js':
      case 'json':
      case 'sh':
      case 'config':
      case 'twig':
      case 'tpl':
      case 'md':
      case 'gitignore':
      case 'c':
      case 'cpp':
      case 'cs':
      case 'py':
      case 'rs':
      case 'map':
      case 'lock':
      case 'dtd':
        img = ['far', 'file-code'];
        break;
      case 'txt':
      case 'ini':
      case 'conf':
      case 'log':
      case 'htaccess':
      case 'yaml':
      case 'yml':
      case 'toml':
        img = ['far', 'file-lines'];
        break;
      case 'css':
      case 'less':
      case 'sass':
      case 'scss':
        img = ['fab', 'css3-alt'];
        break;
      case 'bz2':
      case 'zip':
      case 'rar':
      case 'gz':
      case 'tar':
      case '7z':
      case 'xz':
        img = ['far', 'file-zipper'];
        break;
      case 'php':
      case 'php4':
      case 'php5':
      case 'phps':
      case 'phtml':
        img = ['fas', 'code'];
        break;
      case 'htm':
      case 'html':
      case 'shtml':
      case 'xhtml':
        img = ['fab', 'html5'];
        break;
      case 'xml':
      case 'xsl':
        img = ['far', 'file-excel'];
        break;
      case 'wav':
      case 'mp3':
      case 'mp2':
      case 'm4a':
      case 'aac':
      case 'ogg':
      case 'oga':
      case 'wma':
      case 'mka':
      case 'flac':
      case 'ac3':
      case 'tds':
        img = ['fas', 'music'];
        break;
      case 'm3u':
      case 'm3u8':
      case 'pls':
      case 'cue':
      case 'xspf':
        img = ['fas', 'headphones'];
        break;
      case 'avi':
      case 'mpg':
      case 'mpeg':
      case 'mp4':
      case 'm4v':
      case 'flv':
      case 'f4v':
      case 'ogm':
      case 'ogv':
      case 'mov':
      case 'mkv':
      case '3gp':
      case 'asf':
      case 'wmv':
      case 'webm':
        img = ['far', 'file-video'];
        break;
      case 'eml':
      case 'msg':
        img = ['far', 'envelope'];
        break;
      case 'xls':
      case 'xlsx':
      case 'ods':
        img = ['far', 'file-excel'];
        break;
      case 'csv':
        img = ['far', 'file-lines'];
        break;
      case 'bak':
      case 'swp':
        img = ['far', 'clipboard'];
        break;
      case 'doc':
      case 'docx':
      case 'odt':
        img = ['far', 'file-word'];
        break;
      case 'ppt':
      case 'pptx':
        img = ['far', 'file-powerpoint'];
        break;
      case 'ttf':
      case 'ttc':
      case 'otf':
      case 'woff':
      case 'woff2':
      case 'eot':
      case 'fon':
        img = ['fas', 'font'];
        break;
      case 'pdf':
        img = ['far', 'file-pdf'];
        break;
      case 'psd':
      case 'ai':
      case 'eps':
      case 'fla':
      case 'swf':
        img = ['far', 'image'];
        break;
      case 'exe':
      case 'msi':
      case 'bat':
        img = ['fas', 'terminal'];
        break;
      default:
        img = ['fas', 'file-circle-question'];
        break;
    }
    console.log(img);
    return img;
  }